import { NoData, useAgentCallAgenda } from '../../../../shared';
import { getIsCSR, keycloak } from '@coverright/shared/keycloak';
import { Divider, Drawer, Link as MuiLink, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { getRoute } from '../../../router';
import * as React from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useReactiveVar } from '@apollo/client';
import { menuCollapsed } from '../../menu-toggle-button';
import { useState } from 'react';
import { AgentCallAgendaTaskAssignmentTypeOutput } from '@coverright/data-access/types/enrollment';
import { RoundRobinLead } from '../../../../features';

export const CallAgendaNotification = ({data}: {data: string | null}) => {
  const {assignedClientsCallTasks} = useAgentCallAgenda();
  const isCSR = getIsCSR(keycloak);

  if (isCSR) {
    return <ClientsAssignedToCSRDrawer label={data} />
  } else {
    if (!data) {
      return null;
    }
    return <MuiLink component={Link}
                    to={`/${getRoute('client')}/${assignedClientsCallTasks[0]}`}
                    color={'white.main'} variant={'body2'} flex={1} align={'center'} lineHeight={'30px'} noWrap>
      {data}
    </MuiLink>
  }
}

const ClientsAssignedToCSRDrawer = ({label}: {label: string | null}) => {
  const collapsed = useReactiveVar(menuCollapsed);
  const [open, setOpen] = useState(false);
  const {state} = useAgentCallAgenda();

  const clients = state?.tasks.filter(t => !t.completed && t.currentAssignment?.type === AgentCallAgendaTaskAssignmentTypeOutput.Csr) || [];

  if (!clients.length) {
    return null;
  }

  return <>
    <Typography flex={1} align={'center'} lineHeight={'30px'} noWrap
                onClick={() => setOpen(true)}
                sx={{color: 'white.main', cursor: 'pointer'}} variant={'body2'}>
      {label}
    </Typography>
    <Drawer open={open}
            anchor={'left'}
            sx={{
              '& .MuiBackdrop-root, & .MuiPaper-root': {
                left: collapsed ? 50 : 250,
                boxShadow: 'none',
              }
            }}
            onClose={() => {
              setOpen(false)
            }}>
      <Stack py={2} pl={2} minWidth={400} gap={2}>
        <Typography variant={'subtitle1'}>
          Clients assigned to CSR's
        </Typography>
        <Divider sx={{ mb: 1, mr: 2 }} />

        {!clients.length && <NoData />}

        <OverlayScrollbarsComponent
          style={{height: 'calc(100vh - 115px)', paddingRight: 16}}
          options={{ paddingAbsolute: true }}
          defer
        >
          <Stack gap={1}>
            {clients.map(client => <RoundRobinLead key={client.clientId} client={client} showTime />)}
          </Stack>
        </OverlayScrollbarsComponent>
      </Stack>
    </Drawer>
  </>
}
